import React, { useState,useContext, useEffect } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import JisButton from '../../components/controls/jisButton';
import JisCheckbox from '../../components/controls/jisCheckbox';
import { ShareContext } from '../../context/ShareContext'
import * as Constants from '../../constants';
import * as Services from '../../services';
import JisTabButton from '../../components/controls/jisTabButton';
import BackLoader from '../../components/backloader';
import JisDialog from '../../components/dialog';
import JisDialogForm from '../../components/formdialog';
import { useStepContext } from '@mui/material';
import TiptapEditor from '../../components/controls/tip_tap_editor';

function CMSSetup() {
   const {  activePage, token, setIsExpired,setAlert,frequentData} = useContext(ShareContext);
    const [page, setPage] = useState(null);
    const [tab, setTab] =useState('gallery');
    const [news, setNews]= useState({id:0});
    const [gallery,setGallery]= useState({id:0});
    const [galleryLine,setGalleryLine]= useState({id:0});
    const [team, setTeam]=useState({id:0});
    
    const [newsList, setNewsList] =useState([]);
    const [galleries, setGalleries] =useState([]);
    const [galleryLines, setGalleryLines] = useState([]);
    const [teams, setTeams]  = useState([]);
    const [isDialog, setIsDialog] = useState(false);
    const [html, setHtml] = useState('')
    const [isLine, setIsLine] = useState(false)

    const [err, setErr] =useState('');
    const [loading,setLoading] = useState(false);
    const [sFile, setSFile] =useState(null);
    const [previewPath, setPreviewPath] = useState(false); 
    const [isPreview, setIsPreview] = useState(false);
    
    
    //const docPath= `${Constants.docUrl}cms`;

    useEffect(() => {

              if(tab=='gallery' && !isLine && galleries.length==0){
                console.log('gallery and not isline ')
            onLoadGallery()
        }else if(tab=='gallery' && isLine ){
            console.log('gallery and isline ')
            onLoadGalleryLine()
        }
        else if(tab=='news' && newsList.length==0){
            setIsLine(false);
           onLoadNews()
        }else if(tab=='team' && teams.length==0){
            setIsLine(false);
            onLoadTeams();
        }     
            
        }, [ tab,isLine]);

        const newsTypes=[{value:'Innovation',label:'Innovation'},{value:'Events',label:'Events'},{value:'Other',label:'Other'}]
    const onNewsChange = (e) => {
    setNews({...news, [e.target.name]: e.target.value})   
    }
    const onGalleryChange = (e) => {
    setGallery({...gallery, [e.target.name]: e.target.value})   
    }
    const onGalleryLineChange = (e) => {
    setGalleryLine({...galleryLine, [e.target.name]: e.target.value})   
    }
    const onTeamChange = (e) => {
    setTeam({...team, [e.target.name]: e.target.value})   
    }

    const onLoadGallery=async()=>{
             try {
                  setLoading(true);
                    const resp = await fetch(`${Constants.apiUrl}/cms/gallery`, { 
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    if(data.code==0){
                        setGalleries(data.items);
                    }else if(data.code==-10){
                       setIsExpired(true)
                    }
                  
                   
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    
                  }
       } 
       const onLoadGalleryLine=async()=>{
             try {
                  setLoading(true);
                    const resp = await fetch(`${Constants.apiUrl}/cms/gallery/${gallery.id}/lines`, { 
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    if(data.code==0){
                        setGalleryLines(data.items);
                    }else if(data.code==-10){
                       setIsExpired(true)
                    }
                  
                   
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    
                  }
       }
       const onLoadTeams=async()=>{
             try {
                  setLoading(true);
                    const resp = await fetch(`${Constants.apiUrl}/cms/team`, { 
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    if(data.code==0){
                        setTeams(data.items);
                    }else if(data.code==-10){
                       setIsExpired(true)
                    }
                  
                   
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    
                  }
       } 
       const onLoadNews=async()=>{
             try {
                  setLoading(true);
                    const resp = await fetch(`${Constants.apiUrl}/cms/news`, { 
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    setLoading(false);
                    if(data.code==0){
                        setNewsList(data.items);
                    }else if(data.code==-10){
                       setIsExpired(true)
                    }
                  
                   
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    
                  }
       }

    const onAdd=()=>{
        console.log(`${tab} the current tab`)
        setSFile(null);
        setIsDialog(true);
    }
    const onClose=()=>{
        setIsDialog(false);
        setGallery({id:0});
        setGalleryLine({id:0});
        setTeam({id:0});
        setNews({id:0});
    }
const onEdit=(obj,index)=>{
    console.log(obj);
        if(tab=='gallery' && !isLine){
            setGallery(obj);
        }else if(tab=='gallery' && isLine){
            setGalleryLine(obj);
        }
        else if(tab=='news'){
            setNews(obj);
            setHtml(Constants.b64decode(obj.fullNote))  ;
        }else if(tab=='team'){
            setTeam(obj);
        }
        setIsDialog(true);
    }
   const handleUploadChange =async (e) => {
    
           const files = e.target.files;
           console.log(files[0]);
           var b64=await Constants.toBase64(files[0]);
           var path =URL.createObjectURL(files[0]);
           var fname=Constants.ReduceFilename(files[0]?.name);
   
          var a={ path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};
          setSFile(a);
         
       };
   const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }  
const onReset=()=>{
    setIsDialog(false)
    setSFile(null);
    if(tab=='gallery' && !isLine){
        setGallery({id:0})
        onLoadGallery();
    }
    if(tab=='gallery' && isLine){
        setGalleryLine({id:0})
        onLoadGalleryLine();
    }
    if(tab=='news'){
        setNews({id:0});
        onLoadNews();
    }
    if(tab=='team'){
        setTeam({id:0});
        onLoadTeams();
    }
} 
 
const onSave= async(e)=>{
   e.preventDefault();
    var saveurl="";
    var obj=null;
    if(tab=="gallery" && !isLine){
        saveurl =`${Constants.apiUrl}/cms/gallery`;
        obj={ filename:sFile?.filename,coverImage:sFile?.base64,
            eventOn:gallery.eventOn,title:gallery.title,
            isActive:gallery.isActive,
            id:gallery.id};
    }
    if(tab=="gallery" && isLine){
        saveurl =`${Constants.apiUrl}/cms/gallery-line/${gallery.id}`;
        obj={ filename:sFile?.filename,
            coverImage:sFile?.base64,
            note:galleryLine.note,title:galleryLine.title,
            isActive:galleryLine.isActive, id:galleryLine.id};
    }if(tab=='news'){
        saveurl =`${Constants.apiUrl}/cms/news`;
        obj={ filename:sFile?.filename,
            coverImage:sFile?.base64,
            fullnote: Constants.b64encode(html),
            subTitle:news.subTitle,
            title:news.title,
            isActive:news.isActive, 
            isHighlight:news.isHighlight,
            id:news.id,
            newsOn:news.newsOn,
            newsType:news.newsType=='Other'?news.other:news.newsType
        };
    }if(tab=="team"){
         saveurl =`${Constants.apiUrl}/cms/team`;
        obj={ filename:sFile?.filename,
            coverImage:sFile?.base64,
            
            fullName:team.fullName,
            position:team.position,
            category:team.category=='Other'?team.other:team.category,
            timeframe:team.timeframe,
            currentStatus:team.currentStatus,
            isActive:team.isActive,
            teamLocation:team.teamLocation,
            id:team.id};
    }


            setLoading(true);
            fetch(saveurl, {
            method: 'POST',
            body: JSON.stringify(obj),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                 
                    onReset();
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

const onShowLine=(obj)=>{
    setGallery(obj);
    setIsLine(true);
}

  return (
    <div>
     <div  className='tab_body'>
        <div className='tab_section' style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <JisTabButton code="gallery" isActive={tab=='gallery'}  title="Gallery" data={page} isRoleBased={false}  onClick={()=> setTab('gallery')}/>
          <JisTabButton code="news" isActive={tab=='news'}  title="News" data={page} isRoleBased={false}  onClick={()=> setTab('news')}/>
       <JisTabButton code="team" isActive={tab=='team'}  title="Team" data={page} isRoleBased={false}  onClick={()=> setTab('team')}/>
        </div>
    {tab=='gallery' && !isLine && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Gallery</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Gallery</span><span className='total'>{galleries?.length}</span>
            </div>
            <div style={{display:'flex'}}>
                <div style={{flex:1}}>
                    <table className="case-table">
                        <thead>
                            <tr>
                                <th>SN</th>
                                <th>Title</th>
                                <th>CoverImage</th> 
                                <th>Event Date</th>
                                <th>Status</th>
                                <th>Gallery</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        { galleries.map((g, i) => { return (
                            <tr>
                                <td>{i+1}</td>
                                <td>{g.title}</td>
                                <td> <img src={`${Constants.docUrl}/cms/gallery/${g.coverImage}`} style={{height:50}} /> </td> 
                                <td> {g.eventOn}</td>
                                <td>{g.isActive?'Active':'Inactive'}</td>
                                <td><JisButton  variant='plain' onClick={()=> onShowLine(g)}>The Lines</JisButton></td>
                                <td><JisButton  variant='plain' onClick={()=> onEdit(g,i)}>Edit</JisButton></td>
                            </tr>
                        )} )}
                        </tbody>
                    </table>
                </div>
               
            </div>
            
        </div>
        </div>} 
        {tab=='gallery' && isLine && <div  className='tab_view'>
            <div style={{display:'flex'}}>
                <div style={{flex:1}}>{gallery.title}</div>
              <div style={{textAlign:'right'}}> 
                <JisButton variant='plain' onClick={()=> setIsLine(false)}>Back to Gallery</JisButton>
                <JisButton variant='plain' onClick={onAdd}>Add Gallery Line</JisButton>
                </div>  
            </div>
            
            <div className='table'>
            <div class="section-cases">
                <span>Gallery Line</span><span className='total'>{galleryLines?.length}</span>
            </div>
            <div style={{display:'flex'}}>
                <div style={{flex:1}}>
                    <table className="case-table">
                        <thead>
                            <tr>
                                <th>SN</th>
                                <th>Title</th>
                                <th>CoverImage</th> 
                                <th>Note</th>
                                <th>Status</th>
                                <th>Gallery</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        { galleryLines.map((g, i) => { return (
                            <tr>
                                <td>{i+1}</td>
                                <td>{g.title}</td>
                                <td> <img src={`${Constants.docUrl}/cms/gallery/${gallery.id}/${g.coverImage}`} style={{height:50}} /></td> 
                                <td> {g.note}</td>
                                <td>{g.isActive?'Active':'Inactive'}</td>
                                <td><JisButton  variant='plain' onClick={()=> {setIsLine(true); onEdit(g,i)}}>The Lines</JisButton></td>
                                <td><JisButton  variant='plain' onClick={()=> onEdit(g,i)}>Edit</JisButton></td>
                            </tr>
                        )} )}
                        </tbody>
                    </table>
                </div>
                
            </div>
            
        </div>
        </div>}   
       {tab=='news' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton  variant='plain' onClick={onAdd}>Add News</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>News</span><span className='total'>{newsList?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Sub Title</th>
                        <th>Cover Image</th>
                        <th>News Date</th>
                        <th>News Type</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                   { newsList.map((g, i) => { return (
                    <tr>
                        <td>{i+1}</td>
                        <td>{g.title}</td>
                        <td>{g.subTitle}</td>
                        <td> <img src={`${Constants.docUrl}/cms/news/${g.coverImage}`} style={{height:50}} /> </td> 
                        <td>{g.newsOn}</td>
                        <td>{g.newsType}</td>
                        <td><JisButton onClick={()=>onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 
       {tab=='team' && <div  className='tab_view'>
            <div style={{textAlign:'right'}}> <JisButton variant='plain' onClick={onAdd}>Add Team</JisButton></div>
            <div className='table'>
            <div class="section-cases">
                <span>Teams</span><span className='total'>{teams?.length}</span>
            </div>
            <table className="case-table">
                <thead>
                    <tr>
                       <th>Full Name</th>
                       <th>Position</th>

                       <th>Category</th> 
                       <th>Time frame</th>
                       <th>Cover Image</th>
                       <th>Status</th>
                       <th>Active</th>
                       
                    </tr>
                </thead>
                <tbody>
                   { teams.map((g, i) => { return (
                    <tr>
                        <td>{g.fullName}</td>
                        <td>{g.position}</td>
                        <td>{g.category}</td>
                        <td>{g.timeframe}</td>
                         <td> <img src={`${Constants.docUrl}/cms/team/${g.coverImage}`} style={{height:50}} /> </td> 
                         <td>{g.currentStatus}</td>
                         <td>{g.isActive?'Active':'Inactive'}</td>
                          <td><JisButton  variant='plain' onClick={()=> onEdit(g,i)}>Edit</JisButton></td>
                    </tr>
                   )} )}
                </tbody>
            </table>
        </div>
        </div>} 
     </div>
     <BackLoader open={loading} />
   {isDialog && tab=='gallery' && !isLine && <JisDialogForm title="Gallery" onClose={onClose}>
        <div>
            <form  onSubmit={onSave}>
                <div  className="input-group">
                    <label> Title <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <input placeholder='title' name="title" required={true} value={gallery.title}  onChange={onGalleryChange}  /> 
                    </div>
                </div>
                 <div>
                    {
                        gallery.coverImage!=null && gallery.coverImage!='' &&
                        <div>   
                           <img src={`${Constants.docUrl}/cms/gallery/${gallery.coverImage}`} style={{height:200}} />
                        </div>
                    }
                <div className="btn-upload">
                    <input type="file"  accept="image/*" id={`file-upload-${0}`} onChange={(e) => handleUploadChange(e)} />
                    <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null? 'Choose Cover Image': Constants.ReduceString( sFile?.filename,30)}
                    </label>
                </div> 
                </div>

                <div  className="input-group">
                    <label>Event On <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <input placeholder='Event On' name="eventOn" required={true} value={gallery.eventOn} type='date'  onChange={onGalleryChange}  /> 
                    </div>
                </div>
                <JisCheckbox value={gallery.isActive} label="Active" onChange={(e)=>setGallery({...gallery,isActive:e})} />

                <div><JisButton type='submit'>{gallery.id==0?'Save':'Update'}</JisButton></div> 
            </form>
        </div>
     </JisDialogForm>}  
     {isDialog && tab=='gallery' && isLine && <JisDialogForm title="Gallery Line" onClose={onClose}>
        <div>
            <form  onSubmit={onSave}>
                <div  className="input-group">
                    <label> Title <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <input placeholder='title' name="title" required={true} value={galleryLine.title}  onChange={onGalleryLineChange}  /> 
                    </div>
                </div>
                 <div>
                    {
                        galleryLine.coverImage!=null && galleryLine.coverImage!='' &&
                        <div>   
                           <img src={`${Constants.docUrl}/cms/gallery/${gallery.id}/${galleryLine.coverImage}`} style={{height:200}} />
                        </div>
                    }
                <div className="btn-upload">
                    <input type="file"  accept="image/*" id={`file-upload-${0}`} onChange={(e) => handleUploadChange(e)} />
                    <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null? 'Choose Cover Image': Constants.ReduceString( sFile?.filename,30)}
                    </label>
                </div> 
                </div>

                <div  className="input-group">
                    <label>Note <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <input placeholder='Note' name="note" required={true} value={galleryLine.note}   onChange={onGalleryLineChange}  /> 
                    </div>
                </div>
                <JisCheckbox value={galleryLine.isActive} label="Active" onChange={(e)=>setGalleryLine({...galleryLine,isActive:e})} />

                <div><JisButton type='submit'>{galleryLine.id==0?'Save':'Update'}</JisButton></div> 
            </form>
        </div>
     </JisDialogForm>}

   {isDialog && tab=='news' && <JisDialogForm title="News" onClose={onClose}>
             <form  onSubmit={onSave}>

            <div  className="input-group">
                <label> Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Title'
                    name="title"
                    value={news.title}
                    onChange={onNewsChange}
                    required={true}
                  />
                </div>
                </div>
                <div  className="input-group">
                <label>Sub Title</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Sub Title'
                    name="subTitle"
                    value={news.subTitle}
                    onChange={onNewsChange}
                    required={true}
                  />
                </div>
                </div>
                <div>
                    {
                        news.coverImage!=null && news.coverImage!='' &&
                        <div>   
                           <img src={`${Constants.docUrl}/cms/news/${news.coverImage}`} style={{height:200}} />
                        </div>
                    }
                <div className="btn-upload">
                    <input type="file"  accept="image/*" id={`file-upload-${0}`} onChange={(e) => handleUploadChange(e)} />
                    <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null? 'Choose Cover Image': Constants.ReduceString( sFile?.filename,30)}
                    </label>
                </div> 
                </div>
                <div  className="input-group">
                <label>Full Note</label>
                <div className='input-wrapper'>
                   <div style={{  padding: '20px' }}>
                            <TiptapEditor initialContent={html} onChange={(content) => setHtml(content)} />
                 </div>
                </div>
                </div>
                <div className="select-group">
                <label>
                    News Type:  
                </label>
                <select name="newsType" value={news.newsType}  onChange={onNewsChange} required>
                   <option value="">Select </option>
                              {newsTypes.map((opt,ind) => (
                              <option key={ind} value={opt.value}>
                                  {opt.label}
                              </option>
                              ))}
                </select>
                
            </div>
           {news.newsType=='Other' && <div  className="input-group">
                <label> Specity Type</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Other Type'
                    name="other"
                    value={news.other}
                    onChange={onNewsChange}
                    required={true}
                  />
                </div>
                </div>} 
             
             <div  className="input-group">
                    <label>News On <span className="required">*</span></label>
                    <div className='input-wrapper'>
                        <DynamicIcon iname="phone_in_talk" />
                        <input placeholder='News on' name="newsOn" required={true} value={news.newsOn} type='date'  onChange={onNewsChange}  /> 
                    </div>
                </div>
<JisCheckbox value={news.isHighlight} label="Is Highlight" onChange={(e)=>setNews({...news,isHighlight:e})} />
             <JisCheckbox value={news.isActive} label="Active" onChange={(e)=>setNews({...news,isActive:e})} />
            <div><JisButton type='submit'>{news.id==0?'Save':'Update'} </JisButton></div> 

            </form>
     </JisDialogForm>}  
{isDialog && tab=='team' && <JisDialogForm title="Team" onClose={onClose}>
             <form  onSubmit={onSave}>

            <div  className="input-group">
                <label> Full Name</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Full Name'
                    name="fullName"
                    value={team.fullName}
                    onChange={onTeamChange}
                    required={true}
                  />
                </div>
                </div>
                <div>
                    {
                        team.coverImage!=null && team.coverImage!='' &&
                        <div>   
                           <img src={`${Constants.docUrl}/cms/team/${team.coverImage}`} style={{height:200}} />
                        </div>
                    }
                <div className="btn-upload">
                    <input type="file"  accept="image/*" id={`file-upload-${0}`} onChange={(e) => handleUploadChange(e)} />
                    <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                    {sFile?.path == null? 'Choose Cover Image': Constants.ReduceString( sFile?.filename,30)}
                    </label>
                </div> 
                </div>
                <div  className="input-group">
                <label>Position</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Position'
                    name="position"
                    value={team.position}
                    onChange={onTeamChange}
                    required={true}
                  />
                </div>
                </div>
                <div className="select-group">
                <label>
                    Category 
                </label>
                <select name="category" value={team.category}  onChange={onTeamChange} required>
                    <option value="">Select Cateogry </option>
                   <option value="Court Leadership">Court Leadership</option>
                   <option value="Principal Officers">Principal Officers</option>
                   <option value="Head of Unit">Head of Unit</option>
                   <option value="Retired Chief Judges">Retired Chief Judges</option>
                   <option value="Retired Elevated Deceased Judges">Retired Elevated Deceased Judges</option>
                   <option value="Judges">Judges</option>
                   <option value="Magistrates">Magistrate Judges</option>
                   <option value="Other">Other</option>
                </select>
                
            </div>
              {team.category=='Other' && <div  className="input-group">
                <label> Other Category</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    placeholder='Other Category'
                    name="other"
                    value={team.other}
                    onChange={onTeamChange}
                    required={true}
                  />
                </div>
                </div>}  
             
             <div  className="input-group">
                    <label>Current Status</label>
                    <div className='input-wrapper'>
                        <input placeholder='Status eg Active, Retired, Deceased' name="currentStatus" value={team.currentStatus}   onChange={onTeamChange}  /> 
                    </div>
                </div>
                <div  className="input-group">
                    <label>Timeframe</label>
                    <div className='input-wrapper'>
                        <input placeholder='eg Oct 12, 1986 - Oct 14, 1994' name="timeframe" value={team.timeframe}   onChange={onTeamChange}  /> 
                    </div>
                </div>
                <div  className="input-group">
                    <label>Court Number</label>
                    <div className='input-wrapper'>
                        <input placeholder='e.g Room 1' name="noOfCourt" value={team.noOfCourt}   onChange={onTeamChange}  /> 
                    </div>
                </div>
                 <div  className="input-group">
                    <label>Team Location</label>
                    <div className='input-wrapper'>
                        <input placeholder='eg Ikeja' name="teamLocation" value={team.teamLocation}   onChange={onTeamChange}  /> 
                    </div>
                </div>


             <JisCheckbox value={team.isActive} label="Active" onChange={(e)=>setTeam({...team,isActive:e})} />
            <div><JisButton type='submit'>{team.id==0?'Save':'Update'} </JisButton></div> 

            </form>
     </JisDialogForm>}  

    </div>
  );
}

export default CMSSetup;